import { idp_status } from '../idp.config';

export const IDP_FILTER_DATA = [
    {
        key: "goal_Icontains",
        ui_flow: "input_box",
        label: "Goal",
        default: true
    },
    {
        key: "status",
        ui_flow: "dropdown",
        label: "Status",
        choice: [
            {
                key: idp_status?.ToDo?.for_mutation,
                label: "To Do"
            },
            {
                key: idp_status?.Draft?.for_mutation,
                label: "Draft"
            },
            {
                key: idp_status?.InProgress?.for_mutation,
                label: "In Progress"
            },
            {
                key: idp_status?.Approved?.for_mutation,
                label: "Approved"
            },
            {
                key: idp_status?.Pedning_Approval?.for_mutation,
                label: "Pending"
            },
            {
                key: idp_status?.Completed?.for_mutation,
                label: "Completed"
            },
            {
                key: idp_status?.Revise?.for_mutation,
                label: "Revise"
            }
        ]
    }
]; 